import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { useUserAction } from '../../../helpers/custom-hooks';

const ValidateAccess = ({ pageType, isSubscriber, promo_replace_key, promo_key }) => {
  const [dynamicAdUnitName, setDynamicAdUnitName] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showAd, setShowAd] = useState(false);
  const [isAdPage, setIsAdPage] = useState(false);
  const hasUserAction = useUserAction(); // <-- Get the boolean state from the hook

  useEffect(() => {
    const isAdPage =
      window?.location?.pathname === '/ad/detail' ||
      window?.location?.pathname === '/ad/misc' ||
      window?.location?.pathname.includes('/lite');
    setIsAdPage(isAdPage);
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    const pathname = window.location.pathname.substring(1).split('/')[0];
    const renderAd = pathname !== 'bq-brand-studio' && pageType !== 'video-page-test';
    setShowAd(renderAd);

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    // Return early if no user action has occurred yet
    if (!hasUserAction && !isAdPage) {
      return;
    }

    if (!showAd) return;

    const deviceType = isMobile ? 'WAP' : 'Desktop';
    const queryParams = new URLSearchParams(window.location?.search);
    const category = window.location.pathname.substring(1).split('/')[0];
    const isPromo =
      category === 'ad' ||
      queryParams?.get('utm_source') === 'Yieldmonk' ||
      queryParams?.get('utm_campaign') === 'veve';
    let utmCampaign = queryParams?.get('utm_campaign');
    if (utmCampaign) {
      utmCampaign = utmCampaign.toLocaleLowerCase();
    }

    if (utmCampaign) {
      if (utmCampaign === promo_key[0]) {
        utmCampaign = promo_replace_key[0];
      } else if (utmCampaign === promo_key[1]) {
        utmCampaign = promo_replace_key[1];
      } else if (utmCampaign === promo_key[2]) {
        utmCampaign = promo_replace_key[2];
      } else if (utmCampaign === promo_key[3]) {
        utmCampaign = promo_replace_key[3];
      } else if (utmCampaign === promo_key[4]) {
        utmCampaign = promo_replace_key[4];
      } else if (utmCampaign === promo_key[5]) {
        utmCampaign = promo_replace_key[5];
      } else if (utmCampaign === promo_key[6]) {
        utmCampaign = promo_replace_key[6];
      } else {
        utmCampaign;
      }
    }
    const isDetailPage =
      pageType === 'story-page' || pageType === 'story-page-test' || pageType === 'video-page-test';
    const isPromotionalAdStoryPage = window?.location?.pathname === '/ad/detail';
    const isHomePage =
      window?.location?.pathname === '/' || window?.location?.pathname === '/lite' || isPromo;
    const formattedPageType = isHomePage
      ? 'Home'
      : isPromotionalAdStoryPage || (isPromo && pageType === 'story-page')
        ? 'detail'
        : isDetailPage
          ? 'Detail'
          : 'Listing';

    let formattedCategory = '';
    if (isPromo) {
      formattedCategory = utmCampaign === 'news1' ? 'aff' : utmCampaign;
    } else if (category === 'lite') {
      formattedCategory = window?.location?.pathname === '/lite/video-page-test' ? 'aff_video' : '';
    } else if (window.location.pathname === '/') {
      formattedCategory = 'homepage';
    } else if (category === 'lite') {
      formattedCategory = window?.location?.pathname === '/lite/video-page-test' ? 'aff_video' : '';
    } else {
      formattedCategory = category.replace(/[-\s]/g, '');
    }

    const baseAdUnitPath = window.location.href.includes('/lite')
      ? `1068322/Test/Profit_Eng/${deviceType}/${formattedPageType}`
      : `/1068322/Profit_Eng/${deviceType}/${formattedPageType}/${formattedCategory}`;

    setDynamicAdUnitName(`${baseAdUnitPath}/Interstitial_320x480`);
  }, [pageType, showAd, hasUserAction, isAdPage]); // <-- Add hasUserAction to the dependency array

  useEffect(() => {
    // Return early if no user action has occurred yet
    if (!hasUserAction && !isAdPage) {
      return;
    }

    const googletag = window.googletag || { cmd: [] };
    googletag.cmd.push(() => {
      if (
        isMobile &&
        dynamicAdUnitName &&
        isSubscriber !== null &&
        !isSubscriber &&
        !window.location.href.includes('aff')
      ) {
        var interstitialSlot320x480 = googletag.defineOutOfPageSlot(
          dynamicAdUnitName,
          googletag.enums.OutOfPageFormat.INTERSTITIAL,
        );
        if (interstitialSlot320x480) {
          interstitialSlot320x480.addService(googletag.pubads());
          googletag.enableServices();
          googletag.display(interstitialSlot320x480.getSlotElementId());
        }
      }

      googletag.pubads().addEventListener('slotRenderEnded', function (event) {
        if (event.slot === interstitialSlot320x480) {
          console.log('Interstitial_320x480 is loaded.');
        }
      });
    });
  }, [isMobile, pageType, isSubscriber, dynamicAdUnitName, hasUserAction, isAdPage]); // <-- Add hasUserAction to the dependency array

  return null;
};

ValidateAccess.propTypes = {
  environment: PropTypes.string,
  pageType: PropTypes.string.isRequired,
  currentPath: PropTypes.string.isRequired,
  isSubscriber: PropTypes.bool,
  promo_key: PropTypes.array.isRequired,
  promo_replace_key: PropTypes.array.isRequired,
};

const DisplayAds = ({ pageType, currentPath, isSubscriber, promo_key, promo_replace_key }) => (
  <ValidateAccess
    pageType={pageType}
    currentPath={currentPath}
    isSubscriber={isSubscriber}
    promo_key={promo_key}
    promo_replace_key={promo_replace_key}
  />
);

DisplayAds.propTypes = {
  pageType: PropTypes.string.isRequired,
  currentPath: PropTypes.string.isRequired,
  isSubscriber: PropTypes.bool.isRequired,
  promo_key: PropTypes.array.isRequired,
  promo_replace_key: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => {
  const publisherConfig = state.qt.config.publisher;
  return {
    currentPath: state.qt.currentPath || '',
    environment: get(publisherConfig, ['ads', 'environment'], 'production'),
    pageType: get(state, ['qt', 'pageType'], 'home-page'),
    isSubscriber: get(state, ['userData', 'isSubscriber'], false),
    promo_key: get(state, ['qt', 'config', 'features', 'promo_key'], []),
    promo_replace_key: get(state, ['qt', 'config', 'features', 'promo_replace_key'], []),
  };
};

export default connect(mapStateToProps, {})(DisplayAds);
